/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { CardComponentEditor } from "cms/components/components/card/edit";
import { CardComponentDisplay } from "cms/components/components/card/display";
import { getComponentZoneLayout } from "cms/components/components/component";

const CardComponent = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <CardComponentDisplay />,
        editComponent: <CardComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

CardComponent.displayName = "CardComponent";
export { CardComponent };
